module.exports = __webpack_public_path__ + "img/icon_sm_qydqs.85789cb0.png";